import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FiltersTabs } from '../../../components/countryside/FiltersTabs/FiltersTabs';
import { selectJsonQuery } from '../../../selectors/filters/selectJsonQuery';
import { setDealType } from '../../../actions/filters';
import { TThunkDispatch } from '../../../types/redux';

const SUBURBAN_DEAL_TYPE_SALE = 1;
const SUBURBAN_DEAL_TYPE_RENT = 2;

function dealTypeFromJsonQuery(jsonQuery: { _type?: string }): number {
  if (jsonQuery._type === 'suburbanrent') {
    return SUBURBAN_DEAL_TYPE_RENT;
  }

  return SUBURBAN_DEAL_TYPE_SALE;
}

export const CountrysideFiltersTabsContainer = () => {
  const jsonQuery = useSelector(selectJsonQuery);

  const dispatch: TThunkDispatch = useDispatch();

  const selectedDealType = dealTypeFromJsonQuery(jsonQuery);

  const onDealTypeSelect = useCallback(
    (_: React.MouseEvent<HTMLButtonElement>, dealType: number) => {
      dispatch(setDealType(dealType));
    },
    [dispatch],
  );

  const items = useMemo(
    () => [
      {
        label: 'Купить',
        isSelected: selectedDealType === SUBURBAN_DEAL_TYPE_SALE,
        clickHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          onDealTypeSelect(event, SUBURBAN_DEAL_TYPE_SALE);
        },
      },
      {
        label: 'Снять',
        isSelected: selectedDealType === SUBURBAN_DEAL_TYPE_RENT,
        clickHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          onDealTypeSelect(event, SUBURBAN_DEAL_TYPE_RENT);
        },
      },
      {
        label: 'Продать',
        url: '/razmestit-obyavlenie/',
      },
      {
        label: 'Построить',
        url: '/country-builders-projects/?utm_medium=zagorod&utm_content=bookmark',
      },
    ],
    [onDealTypeSelect, selectedDealType],
  );

  return <FiltersTabs items={items} />;
};
